
import { AnyAction } from 'redux';
import { LoggedActionService } from './logged.action';
import { ILoggedState, LOGGED_STATE } from './logged.model';

export function loggedReducer(state: ILoggedState =  LOGGED_STATE, action: AnyAction): ILoggedState {

    switch (action.type) {

        case LoggedActionService.SET_LOGGED_USER_CURRENT:
          return {
            ...state,
              logged: action.payload
          };

        case LoggedActionService.REFRESH_TOKEN:
          return {
            ...state,
              logged: {
                ...state.logged,
                token: action.payload,
                tokenCreation: new Date()
              }
          };

    }

    return state;
}
